var _g, _path, _g2, _g3, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBurnedTokens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10949_1508)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9997 6.38146C21.3026 6.38146 25.6175 10.6956 25.6182 15.9983C25.6188 21.3018 21.3046 25.6172 16.001 25.6172L15.999 25.5189L15.9984 25.6172C10.6968 25.6172 6.38256 21.3031 6.38124 16.0003C6.38124 10.6975 10.6961 6.38212 15.9997 6.38146M7.32145 15.9978C7.32145 20.7829 11.2142 24.6768 15.9994 24.6775C20.7806 24.6729 24.6746 20.7802 24.6799 15.9991C24.6806 11.2135 20.7872 7.31949 16.0014 7.31949C13.6836 7.31949 11.5038 8.22175 9.86408 9.86073C8.22506 11.5004 7.32145 13.6795 7.32145 15.9978",
    fill: "#FF5722"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3438 16.0785C12.3438 16.6587 12.4773 17.2044 12.7445 17.7156C13.0117 18.2268 13.3844 18.6528 13.8625 18.9936C13.825 18.8831 13.7969 18.7702 13.7781 18.6551C13.7594 18.54 13.75 18.4271 13.75 18.3166C13.75 18.0219 13.8063 17.7456 13.9188 17.4877C14.0313 17.2298 14.1953 16.9949 14.4109 16.7831L16 15.2495L17.5891 16.7831C17.8047 16.9949 17.9687 17.2298 18.0812 17.4877C18.1937 17.7456 18.25 18.0219 18.25 18.3166C18.25 18.4271 18.2406 18.54 18.2219 18.6551C18.2031 18.7702 18.175 18.8831 18.1375 18.9936C18.6156 18.6528 18.9883 18.2268 19.2555 17.7156C19.5227 17.2044 19.6562 16.6587 19.6562 16.0785C19.6562 15.5811 19.5484 15.0952 19.3328 14.6209C19.1172 14.1466 18.8078 13.7114 18.4047 13.3153C18.2078 13.4535 18.0016 13.5617 17.7859 13.64C17.5703 13.7183 17.3547 13.7574 17.1391 13.7574C16.5672 13.7574 16.0938 13.5663 15.7188 13.1841C15.3437 12.8018 15.1562 12.3206 15.1562 11.7403V11.464C14.725 11.7679 14.3359 12.1041 13.9891 12.4725C13.6422 12.841 13.3469 13.2255 13.1031 13.6262C12.8594 14.0268 12.6719 14.4367 12.5406 14.8558C12.4094 15.2748 12.3438 15.6824 12.3438 16.0785ZM16 16.41L15.0016 17.3771C14.8703 17.5061 14.7695 17.6489 14.6992 17.8054C14.6289 17.962 14.5938 18.1324 14.5938 18.3166C14.5938 18.6942 14.7297 19.0143 15.0016 19.2768C15.2734 19.5393 15.6063 19.6706 16 19.6706C16.3937 19.6706 16.7266 19.5393 16.9984 19.2768C17.2703 19.0143 17.4062 18.6942 17.4062 18.3166C17.4062 18.1324 17.3711 17.962 17.3008 17.8054C17.2305 17.6489 17.1297 17.5061 16.9984 17.3771L16 16.41ZM16 9.99951V11.8232C16 12.1364 16.1102 12.3989 16.3305 12.6107C16.5508 12.8225 16.8203 12.9285 17.1391 12.9285C17.3078 12.9285 17.4648 12.8939 17.6102 12.8248C17.7555 12.7558 17.8844 12.6521 17.9969 12.514L18.25 12.21C18.9438 12.5969 19.4922 13.1357 19.8953 13.8265C20.2984 14.5173 20.5 15.2679 20.5 16.0785C20.5 17.3127 20.0641 18.3581 19.1922 19.2146C18.3203 20.0712 17.2563 20.4995 16 20.4995C14.7437 20.4995 13.6797 20.0712 12.8078 19.2146C11.9359 18.3581 11.5 17.3127 11.5 16.0785C11.5 14.8995 11.9031 13.7643 12.7094 12.6729C13.5156 11.5814 14.6125 10.6903 16 9.99951Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10949_1508)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29436 10.248C6.03383 10.248 5.8221 10.0363 5.8221 9.77383C5.8221 9.51331 6.03448 9.30225 6.29502 9.30225C6.55554 9.30291 6.7666 9.51528 6.7666 9.77581C6.7666 10.0363 6.55488 10.248 6.29436 10.248",
    fill: "#FF5722"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_10949_1508)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40203 12.9249C4.43698 12.8048 4.51613 12.7052 4.62562 12.6452C4.73511 12.5845 4.8624 12.5707 4.98178 12.6057C5.10249 12.6406 5.20142 12.7198 5.2621 12.8292C5.32212 12.9394 5.33663 13.066 5.30233 13.1834C4.39674 16.6183 5.21131 20.2993 7.48088 23.0311C11.3631 27.7034 18.3222 28.3471 22.9959 24.4663C27.6682 20.5842 28.312 13.6246 24.4304 8.95175C22.55 6.68752 19.9005 5.29192 16.9701 5.0215C14.0436 4.74712 11.1797 5.63619 8.91676 7.51591C8.83365 7.58714 8.72746 7.62606 8.61863 7.62672H8.61732C8.47815 7.62672 8.3469 7.56604 8.25654 7.46051C8.17475 7.36421 8.13452 7.24153 8.14441 7.11556C8.1543 6.98959 8.213 6.87483 8.30996 6.79239C10.2636 5.16 12.638 4.20431 15.1774 4.02953C18.3756 3.80661 21.4657 4.84606 23.8823 6.95068C26.299 9.0553 27.7513 11.9751 27.9716 15.172C27.9908 15.4443 28 15.7233 28 15.9997C28.0007 22.6163 22.6179 27.9989 16.0018 27.9995H15.982C15.7934 27.9995 15.6028 27.9949 15.4122 27.9857C14.5745 27.9448 13.7382 27.8155 12.9256 27.6005C6.53176 25.9081 2.70628 19.3284 4.40203 12.9249",
    fill: "#FF5722"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10949_1508",
    x: 2.38135,
    y: 2.38135,
    width: 27.2368,
    height: 27.2358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.647059 0 0 0 0 0.0117647 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10949_1508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10949_1508",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10949_1508",
    x: 1.82202,
    y: 5.30225,
    width: 8.94458,
    height: 8.9458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.647059 0 0 0 0 0.0117647 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10949_1508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10949_1508",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_10949_1508",
    x: 0,
    y: 0,
    width: 32,
    height: 31.9995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.647059 0 0 0 0 0.0117647 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10949_1508"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10949_1508",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurnedTokens);
export default __webpack_public_path__ + "static/media/burnedTokens.34be1e3939af215d6380e14dffceab90.svg";
export { ForwardRef as ReactComponent };